import produce from 'immer';
import { registerReducer } from '../../../StateSetup/RootReducer';

export const ACTION_NAME = 'action/updateCurrentFormDependent';

/**
 * Update current member being modified to model.
 * @param {object} currentFormDependent
 */
export const UpdateCurrentFormDependent = (currentFormDependent) => ({
    type: ACTION_NAME,
    currentFormDependent,
});

/**
 * Updates currentFormDependent in the state with the dependent that will get edited.
 */
export const reducer = produce((state, action) => {
    state.MemberData.currentFormDependent = action.currentFormDependent;
});

registerReducer(ACTION_NAME, reducer);
